<template>
    <div class="wrapper">
        <div class="header">
            <BaseHeader :title="'商家详情'"/>
        </div>
        <div class="content">
            <div class="shop-box">
                <div class="shop-img">
                    <img :src="shopInfo.logo" alt="">
                </div>
                <div class="shop-info">
                    <div class="shop-name">商家简称：{{shopInfo.name}}</div>
                    <div class="shop-tel">垂询电话：{{shopInfo.tel}}
                        <a :href="'tel:' + shopInfo.tel" style="display:block;float:right;margin-top:-3px;margin-left:10px;">
                            <van-icon name="phone-o" size="25" color="#f20f20" ></van-icon>
                        </a>
                    </div>
                    <div class="shop-brief">联系人：{{shopInfo.person}}</div>
                </div>
            </div>
			<div style="text-align: center;background-color: #fff;padding-bottom: 5px;">
				<p style="color: #666666;font-size: 12px;">联系我时，请说是在“收到乐”公众号上看到的，谢谢！</p>
			</div>
            <div class="shop-address">
                <div class="location-img" @click="handleGoLocation(shopInfo.lat,shopInfo.lng,shopInfo.name,shopInfo.address)">
                    <van-icon name="location-o" size="30" color="#f20f20"/>
                </div>
                <div class="address" @click="handleGoLocation(shopInfo.lat,shopInfo.lng,shopInfo.name,shopInfo.address)">
                    <p>{{shopInfo.address}}</p>
                    <p>距离：{{distance}}</p>
                </div>
                <div class="tel">
                    <!-- <a :href="'tel:' + shopInfo.tel">
                        <van-icon name="phone-o" size="25" color="#f20f20" ></van-icon>
                    </a> -->
                    <div class="btn" @click="handleGoLocation(shopInfo.lat,shopInfo.lng,shopInfo.name,shopInfo.address)">
                        <span>去这里</span>
                    </div>
                </div>
            </div>
            <div class="shop-details" v-if="shopInfo.video_url">
                <div class="title" style="padding-bottom: 10px;">商家视频</div>
                <video :src="shopInfo.video_url"
                       controls='true'
                       style="width: 100%;height:240px;"></video>
            </div>
            <div class="shop-details" v-if="shopInfo.con_text">
                <div class="title">商家介绍</div>
                <p  style="text-align: left;padding:10px 0;font-size: 14px;text-indent: 2em;width:90%;margin:auto;">{{shopInfo.con_text}}</p>
                <div v-for="(item,index) in shopInfo.con_img">
                    <img style="display: block" :src="item" alt="">
                </div>
<!--                <div v-html="shopInfo.content"></div>-->
				<div class="title" style="margin-top:10px;">商家收款码</div>
				<div>
					<img style="display: block" :src="shopInfo.qrcode_pay" alt="">
				</div>
            </div>
            <div class="shop-box">
                <div class="shop-img">
                    <img :src="shopInfo.logo" alt="">
                </div>
                <div class="shop-info">
                    <div class="shop-name">{{shopInfo.name}}</div>
                    <div class="shop-tel">{{shopInfo.tel}}
                        <a :href="'tel:' + shopInfo.tel" style="display:block;float:right;margin-top:-3px;margin-left:10px;">
                            <van-icon name="phone-o" size="25" color="#f20f20" ></van-icon>
                        </a>
                    </div>
                    <div class="shop-brief">{{shopInfo.person}}</div>
                </div>
            </div>
			<div style="text-align: center;background-color: #fff;padding-bottom: 15px;margin-top: -10px;">
				<p style="color: #666666;font-size: 12px;">联系我时，请说是在“收到乐”公众号上看到的，谢谢！</p>
			</div>
        </div>
    </div>
</template>

<script>
    import BaseHeader from "../components/BaseHeader";
    import {getShopDetailsService} from  '../service/shopService';
    import {Toast} from 'vant';
    import wx from 'weixin-js-sdk'
    import {getWxSharService} from '../service/weChatService'
	import {isWeixinOrAlipayTools} from '../util/tools';

    export default {
        name: "ShopDetails",
        data(){
            return{
                shopId:0,
                shopInfo:{},
                distance:'',
            }
        },
        mounted(){
            this.shopId = this.$route.params.shopId;
            this.distance = this.$route.params.distance;
            this.getShopDetails();
        },
        methods:{
            getShopDetails(){
                getShopDetailsService(this.shopId).then(res => {
                    if(res.status === 1){
                        this.shopInfo = res.datas;
                    }else{
                        Toast(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                })
            },

            handleGoLocation(lat,lng,name,address) {
				console.log(address);
				const isWeixinOrAlipay = isWeixinOrAlipayTools();
				if(isWeixinOrAlipay === 'WeiXIN'){
					getWxSharService(encodeURIComponent(location.href.split('#')[0])).then(result => {
					    if (result.status === 1) {
					        wx.config({
					            // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					            'appId': result.datas.appId, // 公众号名称，由商户传入
					            'timestamp': result.datas.timestamp, // 时间戳，自1970年以来的秒数
					            'nonceStr': result.datas.nonceStr, // 随机串
					            'signature': result.datas.signature,// 微信签名
					            'jsApiList': ['openLocation'] // 必填，需要使用的JS接口列表
					        });
					        wx.ready(function () {
					            wx.openLocation({
					                latitude: lat,//目的地latitude
					                longitude: lng,//目的地longitude
					                name: name,
					                address: address,
					                scale: 15//地图缩放大小，可根据情况具体调整
					            });
					        });
					    } else {
					        Toast(result.msg);
					    }
					})
				}else{
					// var backurl = "http://www.shoudaole.cn/dist/#/receiveShopList";
					var url = "https://apis.map.qq.com/tools/routeplan/eword="+address+"&epointx="+lat+"&epointy="+lng+"&topbar=1?referer=收到乐&key=HUHBZ-EQY6K-CRRJD-AJITD-QSGJF-GNFE6&back=0";
					window.location.href=url;
					return false;
				}
            },
        },
        components:{
            BaseHeader,
        }
    }
</script>

<style scoped lang="scss">
    .wrapper{
        .content{
            .shop-box{
                display: flex;
                align-items: center;
                background: #ffffff;
                .shop-img{
                    padding: 12px;
                    margin-right: 10px;
                    box-sizing: border-box;
                    img{
                        width: 80px;
                        height: 80px;
                        border-radius: 10px;
                    }
                }
                .shop-name{
                    color: #000000;
                    font-size: 16px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                }
                .shop-tel{
                    font-size: 14px;
                    padding: 5px 0;
                }
                .shop-brief{
                    font-size: 14px;
                }
            }
            .shop-address{
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 10px;
                box-sizing: border-box;
                background: #ffffff;
                margin: 5px 0;
                .location-img{
                    flex: 10%;
                }
                .address{
                    flex: 75%;
                }
                .tel{
                    flex: 15%;
                }
                .btn{
                    span{
                        white-space: nowrap;
                        background: #00BFFF;
                        color: #ffffff;
                        padding: 5px;
                        box-sizing: border-box;
                        border-radius: 20px;
                        font-size: 12px;
                    }
                }
            }
            .shop-details{
                background: #ffffff;
                padding: 15px;
                .title{
                    text-align: center;
                    padding: 0;
                    font-size: 16px;
                    font-weight: bold;
                }
            }
        }
    }
</style>
<style>
    .shop-details{
        padding: 5px;
        box-sizing: border-box;
    }
    .shop-details img{
        width: 100%;
        height: 100%;
    }

</style>